module.exports = __webpack_public_path__ + "static/liege-2cc72b16e4a204ffd6ea21b2dfc4da34.png";